import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Layout from './components/Layout';
import ProtectedRoute from './auth/protected-route';

import Login from './auth/login';
import ResetPassword from './auth/reset-password';
import NotFound from './components/NotFound';

import HomePage from './pages/HomePage';

import Help from './pages/Help';

import ActorsSummary from './pages/ActorsSummary';
import NetworksSummary from './pages/NetworksSummary';
import ShowsSummary from './pages/ShowsSummary';
import MoviesSummary from './pages/MoviesSummary';

import ActorReport from './pages/ActorReport';
import NetworkReport from './pages/NetworkReport';
import ShowReport from './pages/ShowReport';
import MovieReport from './pages/MovieReport';

import AnticipationReportShows from './pages/AnticipationReportShows';
import AnticipationReportMovies from './pages/AnticipationReportMovies';
import AnticipationReportAll from './pages/AnticipationReportAll';
import AnticipationTracker from './pages/AnticipationTracker';

import AttributionPlatform from './pages/AttributionPlatform';
import AttributionTitle from './pages/AttributionTitle';

import BingeReport from './pages/BingeReport';

import ReleaseNotes from './pages/ReleaseNotes';
import ReportList from './pages/SegmentsList';
import ReportBuilder from './pages/ReportBuilder';

import CharacterVotesByEpisode from './pages/CharacterVotes';
import ShowViewershipByDate from './pages/ShowViewership';
import SearchResults from './pages/SearchResults';
import SystemStatus from './pages/SystemStatus';

import GemReport from './pages/GemReport';
import UserProfile from './pages/UserProfile';

import AffinityReport from './pages/AffinityReport';
import AffinityReportShows from './pages/AffinityReportShows';
import AffinityReportMovies from './pages/AffinityReportMovies';
import Admin from './pages/Admin';

const TvPortalRoutes = () => (
  <Layout>
    <Switch>
      <ProtectedRoute path="/" exact component={HomePage} />
      <ProtectedRoute path="/search-results" exact component={SearchResults} />
      <ProtectedRoute path="/gem-report" exact component={GemReport} />
      <ProtectedRoute path="/profile" exact component={UserProfile} />
      <ProtectedRoute path="/help" exact component={Help} />
      <ProtectedRoute path="/release-notes" exact component={ReleaseNotes} />
      <Route path="/system-status" exact component={SystemStatus} />
      <ProtectedRoute path="/actor/:actorId(\d+)" component={ActorReport} />
      <ProtectedRoute path="/actors" component={ActorsSummary} />
      <ProtectedRoute
        path="/network/:networkId(\d+)"
        component={NetworkReport}
      />
      <ProtectedRoute path="/networks" component={NetworksSummary} />
      <ProtectedRoute
        path="/report/viewership/:showId(\d+)"
        component={ShowViewershipByDate}
      />
      <ProtectedRoute
        path="/shows/anticipation-report"
        component={AnticipationReportShows}
      />
      <ProtectedRoute
        path="/movies/anticipation-report"
        component={AnticipationReportMovies}
      />
      <ProtectedRoute
        path="/report/anticipation-tracker"
        component={AnticipationTracker}
      />
      <ProtectedRoute
        path="/report/anticipation"
        component={AnticipationReportAll}
      />
      <ProtectedRoute
        path="/attribution/platform"
        component={AttributionPlatform}
      />
      <ProtectedRoute path="/attribution/title" component={AttributionTitle} />
      <ProtectedRoute
        path="/report/character-votes-episode/:showId(\d+)"
        component={CharacterVotesByEpisode}
      />
      <ProtectedRoute path="/report/binge" component={BingeReport} />
      <ProtectedRoute path="/shows/affinity" component={AffinityReportShows} />
      <ProtectedRoute
        path="/movies/affinity"
        component={AffinityReportMovies}
      />
      <ProtectedRoute path="/affinity" component={AffinityReport} />
      <ProtectedRoute path="/reports" component={ReportList} exact />
      <ProtectedRoute path="/reports/:uuid" component={ReportBuilder} />
      <ProtectedRoute
        path="/report-builder"
        component={ReportBuilder}
        exact
        key="report-builder"
      />
      <ProtectedRoute path="/movie/:movieId" component={MovieReport} />
      <ProtectedRoute path="/show/:showId(\d+)" component={ShowReport} />
      <ProtectedRoute path="/shows" component={ShowsSummary} />
      <ProtectedRoute path="/movies" component={MoviesSummary} />
      <ProtectedRoute
        path="/admin"
        exact
        component={Admin}
        redirectPath="/404"
      />
      <Route path="/login" component={Login} />
      <Route path="/reset-password/:hash" component={ResetPassword} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  </Layout>
);

export default TvPortalRoutes;
